import { render, staticRenderFns } from "./RegisterConfirm.vue?vue&type=template&id=bd8cbca0&scoped=true"
import script from "./RegisterConfirm.vue?vue&type=script&lang=js"
export * from "./RegisterConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8cbca0",
  null
  
)

export default component.exports